import { styled, forBrands, Theme, CSSObject } from '@core-ui/react-stitch';

interface BreakPoints {
  readonly isSmall: boolean;
  readonly isMedium: boolean;
  readonly isLarge: boolean;
  readonly isXLarge: boolean;
}
interface ContainerProps {
  readonly breakPoints: BreakPoints;
}

const gapStyles = (): CSSObject => ({
  fontSize: '0.8rem',
});

const oldNavyStyles = (): CSSObject => ({
  fontSize: '0.8rem',
});

const getBrFontStyle = (breakPoints: BreakPoints) => ({
  ...((breakPoints?.isSmall || breakPoints?.isMedium) && {
    fontSize: '0.6875rem',
    lineHeight: '0.813rem',
  }),
  ...(breakPoints?.isLarge && {
    fontSize: '0.8125rem',
    lineHeight: '1.2',
  }),
  ...(breakPoints?.isXLarge && {
    fontSize: '0.9375rem',
    lineHeight: '1.2',
  }),
  letterSpacing: 'unset',
});

const getSpaceBwlines = ({ isLarge }: BreakPoints) =>
  isLarge ? '0.25rem' : '0.1875rem';

const bananaRepublicStyles = (
  theme: Theme,
  breakPoints: BreakPoints
): CSSObject => ({
  fontSize: '0.8125rem',
  fontWeight: 350,
  lineHeight: '1.4',
  ...{
    ...theme.brandFont,
    color: theme.color.wh,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    ...getBrFontStyle(breakPoints),
    '&.product-card__marketing-flag': {
      paddingTop: breakPoints.isXLarge
        ? '0.5rem'
        : getSpaceBwlines(breakPoints),
    },
  },
});

const athletaStyles = (): CSSObject => ({
  fontVariantLigatures: 'none',
  fontSize: '0.8125rem',
  letterSpacing: '1px',
});

const defaultStyles = (): CSSObject => ({
  fontSize: '1rem',
  lineHeight: 1.125,
  letterSpacing: '0.5px',
});

const brandStyles = (theme: Theme, breakPoints: BreakPoints) =>
  forBrands(theme, {
    gap: gapStyles,
    gapfs: gapStyles,
    br: () => bananaRepublicStyles(theme, breakPoints),
    brfs: () => bananaRepublicStyles(theme, breakPoints),
    on: oldNavyStyles,
    at: athletaStyles,
    default: defaultStyles,
  }) as CSSObject;

const Container = styled.div<ContainerProps>(({ theme, breakPoints }) => ({
  ...theme.brandFont,
  color: theme.color.g2,
  textTransform: 'none',
  fontWeight: 'bold',
  ...brandStyles(theme, breakPoints),
}));

export default Container;
